import React from "react";

const Experiences = ({ detail }) => {
  return (
    <div className="card shadow border-0 rounded-4 overflow-hidden mb-5">
      <div className="card-body bg-gradient-secondary-to-primary text-white p-5">
        <div className="row gx-5 align-items-center">
          <div className="col-lg-5 mb-4 mb-lg-0">
            <div className="bg-light rounded-4 p-4 h-100 d-flex flex-column justify-content-center">
              <div className="text-primary fw-bolder fs-4 mb-3">
                {detail[0]}
              </div>
              <div className="mb-3">
                <div className="fw-bold text-gradient">{detail[1]}</div>
                <div className="text-muted">{detail[2]}</div>
                <div className="text-muted">({detail[3]})</div>
              </div>
              <div className="fst-italic text-muted">{detail[4]}</div>
            </div>
          </div>
          <div className="col-lg-7 d-flex align-items-center">
            <div className="w-100">{detail[5]}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experiences;
